import { useTranslation } from 'react-i18next';
import ErrorMessage from '~/components/ErrorMessage';
import { useQuery } from '~/hooks';
import NotFound from '~/pages/NotFound';
import LeadFollowUpHeader from '~/pages/LeadFollowUp/LeadFollowUpHeader';
import LeadFollowUpLoading from '~/pages/LeadFollowUp/LeadFollowUpLoading';
import RelatedListings from '~/pages/LeadFollowUp/RelatedListings';
import TopSellersSection from '~/pages/LeadFollowUp/TopSellersSection';
import { TOP_SELLER_LEAD_CACHE_KEY } from '~/pages/LeadFollowUp/utils';
import { usePostTopSellerLeadMutation } from '~/redux/api/appApiSlice';
import { useGetListingDetailsQuery } from '~/redux/api/userApiSlice';
import { ListingDetailsType } from '~addListing/types';

export default function LeadFollowUp() {
  const { t } = useTranslation('app');
  const { listing: listingId, lead: leadId, _hash: hash } = useQuery();
  // Read-only view of the mutation `RequestCallButton` fires, so a failed call
  // request reports at the top of the page rather than beside the button.
  const [, { isError: isRequestCallError }] = usePostTopSellerLeadMutation({
    fixedCacheKey: TOP_SELLER_LEAD_CACHE_KEY,
  });
  const { data, isLoading, isError } = useGetListingDetailsQuery(listingId, {
    skip: !listingId,
  });
  const listing: ListingDetailsType | undefined = data?.listing;

  if (!listingId || isError) return <NotFound />;
  if (isLoading || !listing) return <LeadFollowUpLoading />;

  const { section, property_type: propertyType, location } = listing;

  return (
    <div className="flex w-full flex-col gap-3x px-2x py-3x md:gap-4x md:px-5x md:py-4x">
      {isRequestCallError && <ErrorMessage message={t('somethingWrong')} />}
      <LeadFollowUpHeader
        propertyType={propertyType.title}
        section={section.title}
        location={location.title}
      />
      <TopSellersSection
        leadId={leadId}
        propertyType={propertyType}
        location={location}
        section={section}
        hash={hash}
      />
      <RelatedListings
        listingId={listingId}
        propertyType={propertyType}
        location={location}
        section={section}
      />
    </div>
  );
}
